import { DateTimeService } from '@shared/services/DateTimeService';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MeetingsMessage from './MeetingsMessage';
import { meetingKindAction } from './constants';
import { TheoryAccessPromo } from './TheoryAccessPromo';
import { FONT_FAMILY_MAIN, LINKS_COLOR } from '../../theme';

const DateField = styled.span`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: -0.1px;
  color: ${LINKS_COLOR};
`;

const PhoneLink = styled.a`
  color: ${LINKS_COLOR};
`;

export const MessageStep = ({
  currentTime,
  kind,
  hasRemainingAccesses,
  isAlreadyBooked,
  schoolName,
  schoolPhone,
  timeZone,
}) => (
  <>
    <MeetingsMessage title={isAlreadyBooked ? 'Oops' : 'Merci'}>
      {isAlreadyBooked
        ? (
          <>
            {
              'Il semblerait que vous ayez déjà pris un rendez-vous avec cette auto-école. '
              + 'Si vous souhaitez le décaler, merci de les appeler directement par téléphone au '
            }
            <PhoneLink href={`tel:${schoolPhone}`}>{schoolPhone}</PhoneLink>
            .
          </>
        ) : (
          <>
            {`L’auto-école a été informée de votre ${meetingKindAction(kind)} le `}
            <DateField>
              {DateTimeService.formatInTimeZone(new Date(currentTime), timeZone, "d MMMM 'à' HH:mm")}
            </DateField>
            . Nous vous avons envoyé un email de confirmation.
          </>
        )}
    </MeetingsMessage>
    {hasRemainingAccesses && <TheoryAccessPromo schoolName={schoolName} />}
  </>
);

MessageStep.propTypes = {
  currentTime: PropTypes.string.isRequired,
  kind: PropTypes.string.isRequired,
  hasRemainingAccesses: PropTypes.bool.isRequired,
  isAlreadyBooked: PropTypes.bool.isRequired,
  schoolName: PropTypes.string.isRequired,
  schoolPhone: PropTypes.string.isRequired,
  timeZone: PropTypes.string.isRequired,
};
